<template>
    <div class="vue-location-card-details">
        <div class="row">
            <div class="col-12 mb-4">
                <div class="back pb-2">
                    <p class="simple-link__back" @click="handleBackButtonClick">{{ translations.backText }}</p>
                </div>
            </div>

            <div class="col-12">
                <img v-if="location.image" :src="location.image" class="image img-fluid mb-4" alt="">

                <h2 class="name virtual-h3 mb-3">
                  <a :href="location.url">{{ location.name }}</a>
                </h2>

                <aut-alert v-if="location.tempLocationWarning" :alert-text="location.tempWarningText"></aut-alert>

                <p class="address mb-3">
                    {{ location.streetName }} {{ location.houseNumber }}<br>
                    {{ location.postalCode }}, {{ location.place }}<br>
                </p>

                <p class="opening-hours mb-3" :class="{ 'is-open': location.openingHours.isOpen || location.openingHours.aboutToOpen }">
                    <template v-if="location.openingHours.aboutToOpen && !location.openingHours.isOpen"><span>{{ translations.openAt }} {{ location.openingHours.currentDay.starthours }}</span></template>
                    <template v-if="location.openingHours.isOpen"><span>{{ translations.open }}</span> {{ translations.until }} {{ location.openingHours.currentDay.endhours }}</template>
                    <template v-if="!location.openingHours.isOpen && !location.openingHours.aboutToOpen"><span>{{ translations.closed }}</span></template>
                </p>

                <a :href="location.phoneNumber | phoneFormatter" @click="clickPhone(location.name, location.phoneNumber)" class="phone d-block">{{ location.phoneNumber }}</a>
                <a :href="`mailto:${location.email}`" @click="clickMail(location.name, location.email)" class="email d-block">{{ location.email }}</a>

                <div class="button-wrapper mt-3">
                    <a :href="location.url" class="go-to-location btn-primary m-0" style="font-size: 1em; width: 100%;">{{  translations.goToLocation }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PhoneNumberFormatter from "../../mixins/PhoneNumberFormatter";
import translations from "../../mixins/translations";

export default {
    name: "LocationCardDetails",

    mixins: [PhoneNumberFormatter, translations],

    props: {
        location: {
            type: Object,
            required: true
        },
        eventBus: {},
    },

    computed: {
        hasOpeningHours() {
            return ! lodash.isNil(this.location.openingHours.currentDay);
        }
    },

    methods: {
        handleBackButtonClick() {
            this.eventBus.$emit('location-card-back-button-clicked');
            this.eventBus.$emit('reset-map');
        },
        clickPhone(name, phone, location_id) {
            window.dataLayer.push({
                'event': 'click_phone',
                'values': [{
                    'name': name,
                    'location_id': location_id,
                    'item_name': phone
                }]
            })
        },
        clickMail(name, mail, location_id) {
            window.dataLayer.push({
                'event': 'click_mail',
                'values': [{
                    'name': name,
                    'location_id': location_id,
                    'item_name': mail
                }]
            })
        }
    }
}
</script>
